import { Billing } from "@screencloud/studio-billing-sdk/client";
import { appConfig } from "src/appConfig";
import { ssm } from "src/state/session/ssm";

/**
 * Thrown when there is no session token or billing v2 has no base URL in the app config.
 *
 * @remarks
 * A missing base URL is a deployment misconfiguration. `getBillingVersion` treats it as "no billing v2", so the org
 * keeps today's billing v1 behaviour; the billing v2 page surfaces it as an error.
 */
export class BillingV2NotConfiguredError extends Error {
  constructor() {
    super("Billing v2 is not configured");
    this.name = "BillingV2NotConfiguredError";
  }
}

/**
 * The billing v2 SDK client for the current session.
 *
 * @throws {@link BillingV2NotConfiguredError} when there is no session token or billing v2 is not configured.
 */
export const getBillingV2Client = (): Billing => {
  const token = ssm.current.token;
  if (!token || !appConfig.billingV2BaseURL) {
    throw new BillingV2NotConfiguredError();
  }
  return new Billing({ token, baseUrl: appConfig.billingV2BaseURL });
};
